import { render } from "./Tem032.vue?vue&type=template&id=1c6ed437"
import script from "./Tem032.vue?vue&type=script&lang=js"
export * from "./Tem032.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__